import { createRouter, createWebHistory } from 'vue-router'
import { getToken, hasPermission } from '../utils/auth'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    redirect: '/batch-list'
  },
  {
    path: '/batch-list',
    name: 'BatchList',
    component: () => import('../views/BatchList.vue'),
    meta: { title: '收单批次' }
  },
  {
    path: '/batch-detail/:batchNo',
    name: 'BatchDetail',
    component: () => import('../views/BatchDetail.vue'),
    meta: { title: '导入批次详情' }
  },
  {
    path: '/excel-file-list',
    name: 'ExcelFileList',
    component: () => import('../views/ExcelFileList.vue'),
    meta: { title: '收单清单' }
  },
  {
    path: '/excel-file-detail/:listNo',
    name: 'ExcelFileDetail',
    component: () => import('../views/ExcelFileDetail.vue'),
    meta: { title: '收单清单详情' }
  },
  {
    path: '/system/users',
    name: 'UserManage',
    component: () => import('../views/system/UserManage.vue'),
    meta: { title: '用户管理', permission: 'user:list' }
  },
  {
    path: '/system/menus',
    name: 'MenuManage',
    component: () => import('../views/system/MenuManage.vue'),
    meta: { title: '菜单管理', permission: 'menu:list' }
  },
  {
    path: '/system/roles',
    name: 'RoleManage',
    component: () => import('../views/system/RoleManage.vue'),
    meta: { title: '角色管理', permission: 'role:list' }
  },
  {
    path: '/system/op-logs',
    name: 'OpLog',
    component: () => import('../views/system/OpLog.vue'),
    meta: { title: '系统操作日志', permission: 'log:operation' }
  },
  {
    path: '/system/login-logs',
    name: 'LoginLog',
    component: () => import('../views/system/LoginLog.vue'),
    meta: { title: '登录日志', permission: 'log:login' }
  },
  {
    path: '/order-sync',
    name: 'OrderSync',
    component: () => import('../views/order-sync/Index.vue'),
    meta: { title: '订单上传' }
  },
  {
    path: '/order-sync/detail/:id',
    name: 'OrderSyncDetail',
    component: () => import('../views/order-sync/Detail.vue'),
    meta: { title: '订单批次详情' }
  },
  {
    path: '/coc-order/:id/preview',
    name: 'CocPreview',
    component: () => import('../views/order-sync/CocPreview.vue'),
    meta: { title: 'COC上传预览' }
  },
  {
    path: '/order-sync/config',
    name: 'CocSyncConfig',
    component: () => import('../views/order-sync/ConfigManage.vue'),
    meta: { title: '配置管理' }
  },
  // 404 兜底
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = getToken()
  
  // 登录页特殊处理
  if (to.path === '/login') {
    if (token) {
      next('/')
    } else {
      next()
    }
    return
  }
  
  // 未登录 → 跳登录页
  if (!token) {
    next('/login')
    return
  }
  
  // 路由级权限检查：如果路由声明了 meta.permission，校验用户是否拥有该权限
  if (to.meta.permission) {
    if (!hasPermission(to.meta.permission)) {
      // 无权限 → 跳首页（避免白屏）
      console.warn(`[Router] 无权限访问 ${to.path}（需要 ${to.meta.permission}）`)
      next('/')
      return
    }
  }
  
  next()
})

export default router
